const CheckedUserMiniIcon = ({color = "#2AA020"}) => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill='none'><path fill={color} fillRule="evenodd" d="M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Zm4.236-10.164a.9.9 0 0 0-1.272-1.272L8.1 10.427 6.936 9.264a.9.9 0 0 0-1.272 1.272l1.8 1.8a.9.9 0 0 0 1.272 0l4.5-4.5Z" clipRule="evenodd"/></svg>
  )
}

export default CheckedUserMiniIcon;